import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const pt = {
  common: {
    streamItem: 'Item do fluxo',
    description: 'Descrição',
    httpMethod: 'Método HTTP',
    path: 'Caminho',
    copyDefault: 'Copiar valor padrão',
    copyExample: 'Copiar valor de exemplo',
  },
  search: {
    label: 'Buscar',
    inputLabel: 'Digite o termo de busca',
    open: 'Abrir Busca',
    placeholder: 'Buscar...',
    clear: 'Limpar Busca',
    noResults: 'Nenhum resultado encontrado',
    keyboardShortcut: 'Atalho de Teclado:',
    command: 'Command',
    control: 'Control',
    results: 'Resultados da Busca de Referência',
    navigate: 'Navegar',
    select: 'Selecionar',
    instructions:
      'Pressione seta para cima / seta para baixo para navegar, enter para selecionar, digite para filtrar resultados',
    entryHeading: 'Título',
    entryOperation: 'Operação',
    entryTag: 'Tag',
    entryTagGroup: 'Grupo de Tags',
    entryWebhook: 'Webhook',
  },
  navigation: {
    introduction: 'Introdução',
    closeGroup: 'Fechar Grupo',
    closeMenu: 'Fechar Menu',
    openGroup: 'Abrir Grupo',
    openMenu: 'Abrir Menu',
    operations: 'Operações',
    endpoints: 'Endpoints de {name}',
    showAllEndpoints: 'Mostrar todos os endpoints de {name}',
    sidebarFor: 'Barra lateral de {name}',
    mainContent: 'Documentação da API para {name}',
    collapsed: 'Recolhido',
    webhooks: 'Webhooks',
    channels: 'Canais',
  },
  server: {
    label: 'Servidor',
    select: 'Selecione um servidor',
  },
  info: {
    termsOfService: 'Termos de Serviço',
  },
  asyncapi: {
    servers: 'Servidores',
    protocols: 'Protocolos',
  },
  clientLibraries: {
    heading: 'Bibliotecas Cliente',
    more: 'Mais',
    selectAll: 'Selecionar de todos os clientes',
    searchLabel: 'Pesquisar clientes',
    changeClient: 'Alterar a linguagem do exemplo de código',
  },
  operation: {
    codeSampleUnavailable: 'Nenhuma amostra de código disponível para este exemplo.',
    body: 'Corpo',
    cookies: 'Cookies',
    headers: 'Cabeçalhos',
    pathParameters: 'Parâmetros de Caminho',
    queryParameters: 'Parâmetros de Consulta',
    requestBody: 'Corpo da Requisição',
    responses: 'Respostas',
    testRequest: 'Testar Requisição',
    webhook: 'Webhook',
    selectedContentType: 'Tipo de Conteúdo Selecionado',
    callbacks: 'Callbacks',
  },
  response: {
    xmlGenerationLimit:
      'O exemplo XML excede o limite de geração. Forneça um exemplo XML serializado para exibir o conteúdo completo.',
    xmlGenerationFailed: 'Não foi possível gerar um exemplo XML: {message}',
    exampleResponses: 'Exemplos de Respostas',
    noBody: 'Sem Corpo',
    showSchema: 'Mostrar Schema',
    status: 'Status',
  },
  schema: {
    noAllowedValues: 'Nenhum valor satisfaz esta restrição enum.',
    example: 'Exemplo',
    examples: 'Exemplos',
    default: 'Padrão',
    schema: 'Schema',
    emptyObject: 'Objeto vazio',
    showAdditionalProperties: 'Mostrar propriedades adicionais',
    forName: 'para {name}',
    showSchemaDetails: 'Mostrar Detalhes do Schema',
    oneOf: 'Um de',
    anyOf: 'Qualquer um de',
    allOf: 'Todos de',
    not: 'Não',
    unknownType: 'tipo desconhecido',
    propertyCount: 'Propriedades: {count}',
    headerCount: 'Cabeçalhos: {count}',
    recursiveReference: 'Referência recursiva a {name}',
    recursive: 'recursivo',
    additionalProperties: 'propriedades adicionais',
    const: 'const',
    deprecated: 'obsoleto',
    discriminator: 'Discriminador',
    enum: 'enum',
    format: 'Formato',
    greaterThan: 'maior que',
    keys: 'chaves',
    lessThan: 'menor que',
    max: 'máx',
    min: 'mín',
    maxLength: 'tamanho máximo',
    minLength: 'tamanho mínimo',
    multipleOf: 'múltiplo de',
    nullable: 'aceita nulo',
    propertyNames: 'nomes de propriedades',
    pattern: 'Padrão',
    copyPattern: 'Copiar padrão',
    readOnly: 'somente leitura',
    required: 'obrigatório',
    hideValues: 'Ocultar valores',
    showAllValues: 'Mostrar todos os valores',
    type: 'Tipo',
    unique: 'único',
    values: 'valores',
    writeOnly: 'somente escrita',
  },
  download: {
    openapi: 'Baixar Documento OpenAPI',
    asyncapi: 'Baixar Documento AsyncAPI',
    asFormat: '{label} em {format}',
  },
  models: {
    label: 'Modelos',
  },
  actions: {
    copyAsMarkdown: 'Copiar como Markdown',
    copied: 'Copiado',
    copyMarkdownFailed: 'Não foi possível copiar o Markdown',

    copyLink: 'Copiar link',
    copyLinkTo: 'Copiar link para {name}',
    copyToClipboard: 'Copiar link para a área de transferência',
    copyEndpointUrl: 'Copiar URL do endpoint',
    showMore: 'Mostrar Mais',
  },
  agent: {
    askAi: 'Perguntar à IA',
    askAiAgent: 'Perguntar ao Agente de IA',
    close: 'Fechar Cliente',
  },
  mcp: {
    generate: 'Gerar MCP',
    connect: 'Conectar MCP',
  },
  developerTools: {
    title: 'Ferramentas de Desenvolvedor',
    configure: 'Configurar',
    share: 'Compartilhar',
    deploy: 'Implantar',
    scalarConfiguration: 'Configuração do Scalar',
    theme: 'Tema',
    layout: 'Layout',
    layoutOptions: 'Opções de Layout',
    intro:
      'As ferramentas de desenvolvedor permitem personalizar a aparência e o comportamento da sua documentação. Você também pode compartilhar sua documentação usando o Scalar Registry.',
    disableToolbarBefore: 'Para desativar a barra de ferramentas, defina',
    disableToolbarAfter: 'na sua configuração.',
    localhostOnly: 'As ferramentas de desenvolvedor só aparecerão ao rodar em localhost.',
    layoutModern: 'Moderno',
    layoutClassic: 'Clássico',
    showSidebar: 'Mostrar Barra Lateral',
    defaultOpenFirstTag: 'Abrir Primeira Tag por Padrão',
    defaultOpenAllTags: 'Abrir Todas as Tags por Padrão',
    expandAll: 'Expandir Todos {label}',
    expandAllResponses: 'Expandir Todas as Respostas',
    hideClientButton: 'Ocultar Botão do Cliente',
    hideDarkModeToggle: 'Ocultar Alternador de Modo Escuro',
    hideModels: 'Ocultar {label}',
    hideSearch: 'Ocultar Busca',
    showOperationId: 'Mostrar ID da Operação',
    hideTestRequestButton: 'Ocultar Botão de Testar Requisição',
    scalarDocs: 'Documentação do Scalar',
    deployDescription:
      'Implante sua documentação no Scalar, a plataforma de documentação moderna para sua API e tudo mais.',
    shareTitle: 'Compartilhe sua Referência de API',
    shareDescription:
      'Envie seu documento OpenAPI para compartilhar sua Referência de API com outras pessoas. Tão fácil quanto apertar um botão.',
    uploadDocument: 'Enviar Documento',
    temporaryLinkExpiration: 'Seu documento será excluído automaticamente após 7 dias.',
    deployOnScalar: 'Implantar no Scalar',
    deployFree: 'Implante sua documentação gratuitamente.',
    additionalFeaturesMightRequire: 'Recursos adicionais podem exigir',
    generate: 'Gerar',
    passwordProtection: 'Proteção por Senha',
    customDomains: 'Domínios Personalizados',
    freeFormContent: 'Conteúdo de formato livre',
    cdnInfrastructure: 'Infraestrutura de CDN',
    pullFromGitHub: 'Importar do GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Linting com Spectral',
    jsonSchemaHosting: 'Hospedagem de JSON Schema',
    askAi: 'Perguntar à IA',
    mcpServers: 'Servidores MCP',
    unableToExportDocument: 'Não foi possível exportar o documento ativo',
    unknownError: 'Ocorreu um erro desconhecido',
  },
  gettingStarted: {
    swaggerEditor: 'Editor Swagger',
    description:
      'Bem-vindo às Referências de API Scalar + Editor Swagger, uma ferramenta gratuita e de código aberto que transforma seu arquivo Swagger/OAS em belas referências de API.',
    showExample: 'Mostrar Exemplo',
    uploadFile: 'Enviar Arquivo',
    integrations: 'INTEGRAÇÕES',
    theming: 'TEMAS',
    features: 'Recursos',
    customize: 'Personalizar',
    customizeDescription: 'Traga sua tipografia e paletas de cores, ou use nossos temas!',
    testing: 'Testes',
    testingDescription: 'Um Cliente de API REST profundamente integrado (Também gratuito e de código aberto)',
    search: 'Busca',
    searchDescription: 'Busca totalmente integrada (usando fuse.js)',
    hosting: 'Hospedagem',
    hostingDescription: 'Hospedagem gratuita de subdomínio em https://apidocumentation.com',
    openApiSwagger: 'OpenAPI e Swagger',
    openApiSwaggerDescription: 'Suporte para OpenAPI 3.1, OpenAPI 3.0 e Swagger 2.0',
    codeSamples: 'Exemplos de Código',
    codeSamplesDescription: 'Exemplos de código para mostrar sua API nas linguagens mais populares',
  },
  footer: {
    poweredByScalar: 'Desenvolvido com Scalar',
  },
  authentication: {
    detailsRequired: 'Autenticação obrigatória',
    detailsOptional: 'Autenticação opcional',
    apiKey: 'Chave de API',
    mutualTLS: 'TLS mútuo',
    apiKeyCookie: 'Envie a chave de API no cookie “{name}”.',
    apiKeyHeader: 'Envie a chave de API no cabeçalho “{name}”.',
    apiKeyQuery: 'Envie a chave de API no parâmetro de consulta “{name}”.',
    title: 'Autenticação',
    accepts: 'Aceita',
    allOf: 'todos de:',
    authentication: 'autenticação',
    optional: 'Autenticação Opcional',
    oneOf: 'um de:',
    required: 'Autenticação Obrigatória',
    requires: 'Requer',
    scopes: 'Escopos OAuth',
  },
} satisfies ApiReferenceTranslations
